import React from 'react'
import PopupLoader from '../views/popups/PopupLoader';
import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

function ImportProgressWarning(props) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <PopupLoader
        title="Alert"
        content={
          <>
            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
              <MDBIcon
                fas
                icon="exclamation-triangle"
                className="me-3 fs-5 mt-1"
                color="warning"
              />
                <div
          dangerouslySetInnerHTML={{
            __html: props.message || t("import_user_progress")
          }}
        />
            </div>
            <MDBModalFooter>
              <MDBBtn
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  props.onOk();
                }}
              >
                {t("ok")}
              </MDBBtn>
            </MDBModalFooter>
          </>
        }
        onShow={props.setShowWarning}
        onClose={props.warningToggle}
      />
    </>
  );
}

export default ImportProgressWarning
